import axios from 'axios';

import { useCallback, useEffect, useRef, useState } from 'react'

// Redux.
import { connect } from 'react-redux';

import PodcastTrack from './PodcastTrack';


const PodcastEpisodes = (props) => {
    const {
        podcastId,

        // Redux
        authenticated,
    } = props;

    const [trackInfos, setTrackInfos] = useState([]);
    const [canLoadMore, setCanLoadMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);

    useEffect(() => {
        axios
            .post('/podcast_tracks', {
                podcastId: podcastId,
                onlyEpisodesWithAI: false
            })
            .then((res) => {
                setTrackInfos(res.data.trackInfos);
            })
            .catch((err) => {
                console.log(err)
            });
    }, [podcastId]);

    const lastElemObserver = useRef();
    const lastElementRef = useCallback(node => {
        if (loadingMore) return; // Don't observe if loading

        // Disconnect previous observer if it exists
        if (lastElemObserver.current) lastElemObserver.current.disconnect();

        lastElemObserver.current = new IntersectionObserver(entries => {
            // Check if the observed element is intersecting (visible) and if there's more data
            if (entries[0].isIntersecting && canLoadMore) {
                
                setLoadingMore(true);
                let lastPublished = trackInfos.at(-1).publishedDate;
                axios
                .post('/podcast_tracks', {
                    podcastId: podcastId,
                    onlyEpisodesWithAI: false,
                    lastPublished: lastPublished
                })
                .then((res) => {
                    setLoadingMore(false);
                    if (res.data.trackInfos.length === 0) {
                        setCanLoadMore(false);
                    } else {
                        let newTrackInfos = trackInfos.concat(res.data.trackInfos)
                        setTrackInfos(newTrackInfos);
                    }

                })
                .catch((err) => {
                    console.log(err)
                });
            }
        });

        // Observe the new node if it exists
        if (node) lastElemObserver.current.observe(node);

    }, [trackInfos, loadingMore, canLoadMore, podcastId]);

    return (
        <div>
            {
                trackInfos.length === 0 ?
                    <></>
                    :
                    <div>
                        <div className='entityInfoSectionTitle'>
                            Episodes
                        </div>
                        {
                            trackInfos.map((trackInfo, index) => (
                                <div key={index} style={{ marginLeft: '20px', padding: '10px 0px', borderTop: index === 0 ? '' : '1px solid rgb(224, 224, 224)' }}>
                                    <PodcastTrack trackInfo={trackInfo} authenticated={authenticated} />
                                    {trackInfos.length - 1 === index && (canLoadMore || loadingMore) ? 
                                        <div ref={lastElementRef} style={{ fontSize: '14px', fontWeight: '500', padding: '30px', textAlign: 'center' }}>
                                            Loading more...
                                        </div> : 
                                        <></>
                                    }
                                </div>
                            ))
                        }
                    </div>
            }
        </div >
    );
}

PodcastEpisodes.propTypes = {

}

PodcastEpisodes.defaultProps = {

}

const mapStateToProps = (state) => ({
    authenticated: state.user.authenticated,
})

const mapActionsToProps = {
}

export default connect(mapStateToProps, mapActionsToProps)(PodcastEpisodes);
